import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';

@Component({
    selector: 'app-master-data',
    templateUrl: './master-data.component.html',
    styleUrls: ['./master-data.component.scss'],
    standalone: false
})
export class MasterDataComponent implements OnInit {

  serviceForm: FormGroup;
  showEditMakePopup: boolean = false;
  makeId!: string;
  metaDataList: any[] = [];
  protected faEdit = faEdit;
  popupType: string;
  errorMessage: any;
  isToster: boolean = false;
  message: any;
  isLoading: boolean = false;
  loader: boolean = false;
  isAdmin: boolean = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterMakeService: MasterMakeService,
    private readonly storageService: StorageService,
  ) {
    this.serviceForm = this.formBuilder.group({
      label: ['', [Validators.required]],
      status: [false],
      amount: [null, [Validators.min(1)]]
    });
    let userDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.isAdmin = userDetailsData?.enrollmentType === 'Company';
  }

  ngOnInit(): void {
    this.getMetaDataDetails();
  }

  getMetaDataDetails() {
    this.loader = true;
    this.masterMakeService.getMetaDataDetails().subscribe({
      next: (res: any) => {
      this.loader = false;
      this.metaDataList = res.data;
    },
      error: (error) => {
      this.errorMessage = error?.error?.error?.message;
      this.loader = false;
    }
    });
  }

  serviceFormPopup(type: string, list?: any) {
    if (type === 'update' && list) {
      this.popupType = 'Update';
      this.serviceForm.patchValue({
        label: list.label,
        status: list.status === 'Active',
        amount: list.amount || null
      });
      this.makeId = list._id;
      this.showEditMakePopup = true;
    } else {
      this.popupType = 'Add';
      this.serviceForm.reset({
        status: true 
      });
      this.showEditMakePopup = true;
    }
  }

  onEditSubmit() {
    this.isLoading = true;
    const payload = {
      label: this.serviceForm.value.label,
      status: this.serviceForm.value.status ? 'Active' : 'Deactive',
      amount: this.serviceForm.value.amount || 0
    };

    if (this.popupType === 'Update') {
      this.masterMakeService.updateMetaDataDetails(payload, this.makeId).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.closePopup();
        this.isToster = true;
        this.getMetaDataDetails();
        this.message = res.message;
      },
      error: (error) => {
        this.errorMessage = error?.error?.error?.message;
        this.isLoading = false;
      }
    });
    } else {
      this.masterMakeService.addMetaDataDetails(payload).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.closePopup();
        this.getMetaDataDetails();
        this.isToster = true;
        this.message = res.message;
      },
      error: (error) => {
        this.errorMessage = error?.error?.error?.message;
        this.isLoading = false;
      }
    });
    }
  }

  closePopup() {
    this.showEditMakePopup = false;
    this.serviceForm.reset();
  }

  closeToster(event: any) {
    this.isToster = false;
  }
}
